<full-modal-config
    class="license-tier-switch-modal"
    modalTitle="{{ l10nKeys.modalTitle | vtranslate }}"
    [modified]="isFormModified"
    (onCancel)="dismiss()"
    (onSubmit)="saveLicenseTierChange()"
    [submitButtonText]="saveLabel"
    [busy]="isBusy()"
    [errors]="editable.errors || error"
    [valid]="form.valid && isFormModified"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section tabTitle="{{ globalL10nKeys.generalLabel | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ globalL10nKeys.generalLabel | vtranslate }}</h3>
                <div
                    class="license-tier-switch-modal__select-area"
                    *ngIf="portalInfo"
                >
                    <div
                        *ngIf="showSwitchToCloudAlert"
                        class="license-tier-switch-modal__card-alert-msg license-tier-switch-modal__card-alert-msg--on-prem sel-license-switch-alert-msg"
                    >
                        <avi-alert-group
                            *ngIf="!infoAlertCleared"
                            alertType="info" 
                            [closable]="true"
                            (onAlertClose)="closeInfoAlert()"
                        >
                            <span 
                                *ngIf="isCloudLicensingEnabled"
                                class="license-tier-switch-modal__card-alert-msg-text license-tier-switch-modal__alert-group-content sel-license-switch-alert-msg-text"
                            >
                                {{ l10nKeys.switchToOnPremDescription | vtranslate }}
                            </span>
                            <span
                                *ngIf="isOnPremLicensingEnabled"
                                class="license-tier-switch-modal__card-alert-msg-text license-tier-switch-modal__alert-group-content sel-license-switch-alert-msg-text"
                            >
                                {{ l10nKeys.switchToCloudDescription | vtranslate }}

                                <a
                                    [href]="aviLoadBalancerLicensingKbUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="license-tier-switch-modal__card-alert-button btn-sm btn-link"
                                >
                                    {{ l10nKeys.disconnectFromOnPremDescription | vtranslate }}
                                </a>
                            </span>
                        </avi-alert-group>
                    </div>

                    <div *ngFor="let tierType of licenseTierTypeList; trackBy: trackByTierType">
                        <license-tier-select-card
                            [tierType]="tierType"
                            [tierInUse]="tierInUse"
                            [tierUsageFraction]="getTierUsageFraction(tierType)"
                            [disabled]="isTierDisabled(tierType)"
                            (onSelect)="selectTier($event)"
                        >
                            <div
                                *ngIf="showConnectNowAlert(tierType)"
                                class="license-tier-switch-modal__card-alert-msg sel-license-switch-alert-msg"
                            >
                                <avi-alert-group alertType="info">
                                    <span
                                        class="license-tier-switch-modal__card-alert-msg-text license-tier-switch-modal__alert-group-content sel-license-switch-alert-msg-text"
                                    >
                                        {{ l10nKeys.completeSetupDescription | vtranslate }}

                                        <button
                                            (click)="handleConnectToCloudLicensing()"
                                            class="license-tier-switch-modal__card-alert-button btn btn-sm btn-link"
                                        >
                                            {{ l10nKeys.connectNow | vtranslate }}
                                        </button>
                                    </span>
                                </avi-alert-group>
                            </div>

                            <div
                                *ngIf="showCloudLicensingSettings(tierType)"
                                class="license-tier-switch-modal__card-settings-form"
                            >
                                <!-- Site Section -->
                                <div
                                    class="license-tier-switch-modal__config-section"
                                    [ngClass]="selectedSiteId && 'license-tier-switch-modal__config-section-site-selected'"
                                >
                                    <div class="full-modal-config__form-control-row">
                                        <div class="full-modal-config__form-control">
                                            <label
                                                aviLabelWithTooltip
                                                for="site-id"
                                                required
                                            >
                                                {{ l10nKeys.siteNameInputLabel | vtranslate }}
                                            </label>
                                            <avi-collection-dropdown
                                                (ngModelChange)="onSiteChange($event)"
                                                [(ngModel)]="selectedSiteId"
                                                [collection]="albServicesSiteCollection"
                                                [disableCreate]="true"
                                                [disabled]="isSiteContactClusterReadOnly"
                                                [disableEdit]="true"
                                                [hideSearch]="true"
                                                [placeholder]="l10nKeys.siteInputPlaceholder | vtranslate"
                                                [preventLoad]="true"
                                                id="site-id"
                                                name="site-id"
                                                required
                                            ></avi-collection-dropdown>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pool Section -->
                                <div
                                    class="license-tier-switch-modal__config-section license-tier-switch-modal__pool-config-section"
                                    *ngIf="selectedSiteId"
                                >
                                    <div class="full-modal-config__form-control-row">
                                        <div class="full-modal-config__form-control">
                                            <label
                                                aviLabelWithTooltip
                                                for="license-pool-selection"
                                                required
                                            >
                                                {{ l10nKeys.licensePoolSelectionInputLabel | vtranslate }}
                                            </label>
                                            <avi-collection-dropdown
                                                [(ngModel)]="selectedPoolId"
                                                [collection]="licensePoolCollection"
                                                [disableCreate]="true"
                                                [disabled]="isCloudLicensingEnabled"
                                                [disableEdit]="true"
                                                [hideSearch]="true"
                                                [placeholder]="l10nKeys.licensePoolSelectionInputPlaceholder | vtranslate"
                                                [preventLoad]="true"
                                                id="pool-name"
                                                name="pool-name"
                                                required
                                            ></avi-collection-dropdown>
                                        </div>
                                    </div>
                                </div>

                                <!-- Default Contact Section -->
                                <div class="full-modal-config__form-control-row">
                                    <div class="full-modal-config__form-control">
                                        <label
                                            aviLabelWithTooltip
                                            for="contact"
                                            required
                                        >
                                            {{ l10nKeys.contactInputLabel | vtranslate }}
                                        </label>
                                        <avi-dropdown
                                            id="contact"
                                            [options]="users"
                                            name="contact"
                                            [(ngModel)]="defaultContact"
                                            placeholder="{{ l10nKeys.contactInputPlaceholder | vtranslate }}"
                                            [disabled]="isSiteContactClusterReadOnly"
                                            [hideSearch]="false"
                                            required
                                        ></avi-dropdown>
                                    </div>
                                </div>

                                <!-- Cluster Name Section -->
                                <div
                                    class="license-tier-switch-modal__config-section"
                                    *ngIf="clusterItem.config?.name"
                                >
                                    <h3 class="license-tier-switch-modal__section-header">{{ l10nKeys.nodeSettingsLabel | vtranslate }}</h3>
                                    <div class="full-modal-config__form-control-row">
                                        <div class="full-modal-config__form-control">
                                            <avi-input-container>
                                                <label
                                                    aviLabelWithTooltip
                                                    for="name"
                                                    fieldName="name"
                                                >
                                                    {{ l10nKeys.clusterNameLabel | vtranslate }}
                                                </label>
                                                <input
                                                    clrInput
                                                    fieldName="name"
                                                    id="name"
                                                    [(ngModel)]="clusterItem.config.name"
                                                    name="name"
                                                    [disabled]="true"
                                                    placeholder="{{ l10nKeys.clusterNamePlaceholder | vtranslate }}"
                                                    readonly
                                                />
                                            </avi-input-container>
                                        </div>
                                    </div>
                                    <div class="license-tier-switch-modal__section-footer">
                                        <cds-button
                                            class="sel-license-switch-cluster-edit-modal"
                                            size="sm"
                                            [disabled]="isSiteContactClusterReadOnly"
                                            (click)="openClusterEditModal()"
                                            (keydown.enter)="openClusterEditModal()"
                                        >
                                            {{ globalL10nKeys.editLabel | vtranslate }}
                                        </cds-button>
                                    </div>
                                </div>

                                <!-- System Settings Section -->
                                <div class="license-tier-switch-modal__config-section">
                                    <h3 class="license-tier-switch-modal__section-header">{{ l10nKeys.systemSettingsLabel | vtranslate }}</h3>

                                    <div class="license-tier-switch-modal__field-row-section">
                                        <div class="full-modal-config__form-control">
                                            <avi-input-container>
                                                <label
                                                    aviLabelWithTooltip
                                                    fieldName="reserve-service"
                                                    for="reserve-service"
                                                >
                                                    {{ l10nKeys.reserveServiceUnitsLabel | vtranslate }}
                                                </label>
                                                <input
                                                    clrInput
                                                    fieldName="reserve-service"
                                                    id="reserve-service"
                                                    name="reserve-service"
                                                    type="number"
                                                    [value]="licenseQuotaConfig?.reservation"
                                                    placeholder="{{ l10nKeys.reserveServiceUnitsPlaceholder | vtranslate }}"
                                                    readonly
                                                />
                                            </avi-input-container>
                                        </div>
                                        <div class="full-modal-config__form-control">
                                            <avi-input-container>
                                                <label
                                                    aviLabelWithTooltip
                                                    fieldName="max-service-unit"
                                                    for="max-service-unit"
                                                >
                                                    {{ l10nKeys.maxServiceUnitsLabel | vtranslate }}
                                                </label>
                                                <input
                                                    clrInput
                                                    fieldName="max-service-unit"
                                                    id="max-service-unit"
                                                    type="number"
                                                    name="max-service-unit"
                                                    [value]="licenseQuotaConfig?.limit"
                                                    placeholder="{{ l10nKeys.maxServiceUnitsPlaceholder | vtranslate }}"
                                                    readonly
                                                />
                                            </avi-input-container>
                                        </div>
                                    </div>

                                    <div class="license-tier-switch-modal__section-footer">
                                        <cds-button
                                            class="sel-license-switch-system-setting-edit-modal"
                                            size="sm"
                                            (click)="openSystemSettingsModal()"
                                            (keydown.enter)="openSystemSettingsModal()"
                                        >
                                            {{ globalL10nKeys.editLabel | vtranslate }}
                                        </cds-button>
                                    </div>
                                </div>
                            </div>
                        </license-tier-select-card>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>

        <full-modal-tab-section
            tabTitle="{{ l10nKeys.proxyHeaderLabel | vtranslate }}"
            *ngIf="portalInfo && isCloudServiceTierSelected"
        >
            <!-- Proxy Section -->
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.proxyHeaderLabel | vtranslate }}</h3>

                <div class="license-tier-switch-modal__config-section license-tier-switch-modal__proxy-section">
                    <h3 class="license-tier-switch-modal__section-header">{{ l10nKeys.proxySettingsLabel | vtranslate }}</h3>

                    <ng-container *ngIf="portalInfoItem?.config?.split_proxy_configuration">
                        <!-- Server Host & Port Row -->
                        <div class="license-tier-switch-modal__field-row-section">
                            <div class="full-modal-config__form-control">
                                <avi-input-container noMarginTop>
                                    <label
                                        aviLabelWithTooltip
                                        for="proxy-server-host"
                                    >
                                        {{ l10nKeys.proxyServerHostLabel | vtranslate }}
                                    </label>
                                    <input
                                        clrInput
                                        id="proxy-server-host"
                                        name="proxy-server-host"
                                        [value]="portalInfoItem.config.split_proxy_configuration.config.host ?? ''"
                                        placeholder="{{ l10nKeys.proxyServerHostPlaceholder | vtranslate }}"
                                        readonly
                                    />
                                </avi-input-container>
                            </div>
                            <div class="full-modal-config__form-control">
                                <avi-input-container noMarginTop>
                                    <label
                                        aviLabelWithTooltip
                                        for="proxy-port"
                                    >
                                        {{ globalL10nKeys.portLabel | vtranslate }}
                                    </label>
                                    <input
                                        clrInput
                                        id="proxy-port"
                                        name="proxy-port"
                                        [value]="portalInfoItem.config.split_proxy_configuration.config.port ?? ''"
                                        placeholder="{{ globalL10nKeys.healthMonitorPortInputPlaceholder | vtranslate }}"
                                        readonly
                                    />
                                </avi-input-container>
                            </div>
                        </div>

                        <!-- Username & Password Row -->
                        <div class="license-tier-switch-modal__field-row-section">
                            <div class="full-modal-config__form-control">
                                <avi-input-container>
                                    <label
                                        aviLabelWithTooltip
                                        for="proxy-username"
                                    >
                                        {{ globalL10nKeys.usernameLabel | vtranslate }}
                                    </label>
                                    <input
                                        clrInput
                                        id="proxy-username"
                                        name="proxy-username"
                                        [value]="portalInfoItem.config.split_proxy_configuration.config.username ?? ''"
                                        placeholder="{{ globalL10nKeys.usernamePlaceholder | vtranslate }}"
                                        readonly
                                    />
                                </avi-input-container>
                            </div>
                            <div class="full-modal-config__form-control">
                                <avi-input-container>
                                    <label
                                        aviLabelWithTooltip
                                        for="proxy-password"
                                    >
                                        {{ globalL10nKeys.passwordLabel | vtranslate }}
                                    </label>
                                    <input
                                        clrInput
                                        id="proxy-password"
                                        name="proxy-password"
                                        type="password"
                                        [value]="portalInfoItem.config.split_proxy_configuration.config.password ?? ''"
                                        placeholder="{{ globalL10nKeys.passwordPlaceholder | vtranslate }}"
                                        readonly
                                    />
                                </avi-input-container>
                            </div>
                        </div>
                    </ng-container>

                    <div class="license-tier-switch-modal__section-footer">
                        <cds-button
                            class="sel-license-switch-proxy-edit-modal"
                            size="sm"
                            (click)="openProxyConfigModal()"
                            (keydown.enter)="openProxyConfigModal()"
                        >
                            {{ globalL10nKeys.editLabel | vtranslate }}
                        </cds-button>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
    </form>

    <full-modal-config_footer *ngIf="showConfigureCloudServicesCheckbox">
        <clr-checkbox-container class="license-tier-switch-modal__setup-cloud-checkbox-container">
            <clr-checkbox-wrapper>
                <input
                    type="checkbox"
                    clrCheckbox
                    name="setupCloudAfter"
                    [(ngModel)]="openCloudModal"
                    id="setupCloudAfter"
                />
                <label
                    for="setupCloudAfter"
                    class="license-tier-switch-modal__setup-cloud-label sel-license-tier-switch-modal__setup-cloud-label"
                >
                    {{ l10nKeys.configureCloudServices | vtranslate }}
                </label>
            </clr-checkbox-wrapper>
        </clr-checkbox-container>
    </full-modal-config_footer>
</full-modal-config>
